import React, { useContext, } from 'react';
import {useSelector} from 'react-redux';

import { PersonalInfo, Field, } from '../../core/inputElements';
import { StepContext, Section, FormContext, EMESection } from '../../core/layoutElements'; 
import useFieldHandlers from '../../core/hooks/use-emefield-handlers.hook';

const STEPID = "steps_Particulars";
const TITLE = "steps_Particulars";
const part_1_ID = "part_1_Particulars";
const part_2_ID = "part_2_OrderDetails";
const problemCheckBoxGroup_ID = "problemCheckBoxGroup";
const part_3_ID = "part_3_SignatoryDetails";

const Particulars = (props) => {
    const {formLocalization, stepIdx } = useContext(FormContext);
    const {formData} = useSelector(store => store.formDetail);
    const { handleFieldChange, getFieldStatus } = useFieldHandlers(); 

    return ( 
        <StepContext.Provider value={{stepId: STEPID, title: TITLE, validations: {}}}>
            {stepIdx === 2 && <EMESection />}
            <Section id={part_1_ID} titleText={formLocalization.part_1_Particulars} inline={props.inline}>
                <Field.Text id="OlsAccName" label={formLocalization.OlsAccName} maxlength={100} required multiline={true} 
                            eMeLabel={getFieldStatus("OlsAccName").autofilled && !getFieldStatus("OlsAccName").edited} 
                            onChange={(value) => handleFieldChange("OlsAccName", value)} />
                <Field.Text id="OlsAccNo" label={formLocalization.OlsAccNo} maxlength={20} multiline={true} />
                <Field.Text id="ContactPerson" label={formLocalization.ContactPerson} maxlength={100} required multiline={true} 
                            eMeLabel={getFieldStatus("ContactPerson").autofilled && !getFieldStatus("ContactPerson").edited} 
                            onChange={(value) => handleFieldChange("ContactPerson", value)} />
                <PersonalInfo.PhoneFax id="ContactPhone" label={formLocalization.ContactPhone} maxlength={20} required 
                                       eMeLabel={getFieldStatus("ContactPhone").autofilled && !getFieldStatus("ContactPhone").edited} 
                                       onChange={(value) => handleFieldChange("ContactPhone", value)} />
                <PersonalInfo.Email id="ContactEmail" label={formLocalization.ContactEmail} maxlength={100} 
                                    eMeLabel={getFieldStatus("ContactEmail").autofilled && !getFieldStatus("ContactEmail").edited} 
                                    onChange={(value) => handleFieldChange("ContactEmail", value)} />
            </Section>
            <Section id={part_2_ID} titleText={formLocalization.part_2_OrderDetails} inline={props.inline}>
                <Field.Dropdown id="TransOrder" label={formLocalization.TransOrder} strike={true} options={formLocalization.field_transOrder_list} />
                <Field.Text id="TransactionNo" label={formLocalization.TransactionNo} maxlength={45} alphanumeric 
                            hideWhen={formData.TransOrder !== "0"} />
                <Field.Text id="TransactionNo" label={formLocalization.OrderNo} maxlength={45} alphanumeric 
                            hideWhen={formData.TransOrder !== "1"} />
                <Field.DatePicker id="DateOfOrder" label={formLocalization.DateOfOrder} onOrBeforeToday />
                <Field.TimePicker id="TimeOfOrder" label={formLocalization.TimeOfOrder} />
                <Field.Dropdown id="OrderType" label={formLocalization.OrderType} strike={true} options={formLocalization.field_orderType_list} />
                <Field.Text id="OrderType_Other" label="" transparentLabel maxlength={200} required  
                            hideWhen={!formData.OrderType || formData.OrderType !== "3"} />
                <Field.Dropdown id="RefType" label="" transparentLabel strike={true} options={formLocalization.field_refType_list} />
                {formData.RefType && formData.RefType == 0 ?
                    <><Field.LookupAddress id="Ref" label="" transparentLabel maxlength={200}  
                                hideWhen={!formData.RefType}/></>
                : formData.RefType ?
                    <><Field.Text id="Ref" label="" transparentLabel maxlength={200}  
                                hideWhen={!formData.RefType}/></>
                : null
                }
            </Section>
            <Section id={problemCheckBoxGroup_ID} titleText={formLocalization.part_3_Issues} inline={props.inline}>
                <Field.Checkbox id="Problems1" label={formLocalization.Problems1} />

                <Field.Checkbox id="Problems2" label={formLocalization.Problems2} />
                <Field.FileUpload   id="LandRegisterAttach" label={formLocalization.LandRegisterAttach} limit="5242880" filter=".jpg,.png,.pdf" 
                                    hideWhen={!formData.Problems2} />

                <Field.Checkbox id="Problems3" label={formLocalization.Problems3} />
                <Field.Dropdown id="ImageProblem" label={formLocalization.ImageProblem} maxlength={15} strike={true} options={formLocalization.field_imageProblem_list} 
                                hideWhen={!formData.Problems3} />
                <Field.FileUpload   id="ImageAttach" label={formLocalization.ImageAttach} limit="5242880"  filter=".jpg,.png,.pdf" 
                                    hideWhen={!formData.Problems3} />

                <Field.Checkbox id="Problems4" label={formLocalization.Problems4} />
                <Field.FileUpload   id="WrongDocAttach" label={formLocalization.WrongDocAttach} limit="5242880"  filter=".jpg,.png,.pdf" 
                                    hideWhen={!formData.Problems4} />

                <Field.Checkbox id="Problems5" label={formLocalization.Problems5} />
                <Field.Text id="RequestFor" label={formLocalization.RequestFor} maxlength={100}  multiline={true} 
                            hideWhen={!formData.Problems5} />
                
                <Field.Checkbox id="Problems6" label={formLocalization.Problems6} />
                <Field.Text id="Others" label={formLocalization.Others} maxlength={200} required multiline={true} 
                            hideWhen={!formData.Problems6} />
            </Section>
        </StepContext.Provider>
    ) 
};

export default {
    stepId: STEPID,
    title: TITLE,
    content: Particulars,
    focusFirstInput: true,
    validations: {},
};
